export function setGraphQLClient(graphQLClient) {
  return {
    type: 'deps/setGraphQLClient',
    payload: {
      graphQLClient,
    },
  }
}

export function getGraphQLClient(state) {
  return state.dependencies.graphQLClient
}

export default function reducer(state = {}, { type, payload }) {
  switch (type) {
    case 'deps/setGraphQLClient': {
      const { graphQLClient } = payload
      return {
        ...state,
        graphQLClient,
      }
    }
    default:
      return state
  }
}
